import AppDispatcher from '../AppDispatcher';

class AppActions {

    getData() {
        AppDispatcher.dispatch( {
            type: "GET_DATA",
        } );
    }

    updatePage(title) {
        AppDispatcher.dispatch( {
            type: "UPDATE_PAGE",
            payload: title,
        } );
    }

    resetData() {
        AppDispatcher.dispatch( {
            type: "RESET_DATA",
        } );
    }

    loading(yesNo) {
        AppDispatcher.dispatch( {
            type: "SET_LOADING",
            payload: yesNo,
        } );
    }

    updateStore(obj = {}){
        AppDispatcher.dispatch( {
            type: "UPDATE_STORE",
            payload: obj,
        } );
    }
}

export default new AppActions();
